module.exports = __webpack_public_path__ + "static/media/options.3a27e744.svg";